/*
 * saraz-conversion-tools.js — rewritten 2026-09-03
 *
 * KEPT (genuine features):
 *   - Ask / Share on WhatsApp buttons on product pages
 *   - Exit-intent WhatsApp help popup
 *   - PIN code delivery-date estimator
 *   - Header trust strip (claims that are actually true)
 *
 * REMOVED (fabricated or unsupportable):
 *   - "N people viewing this right now"  -> random integer 8-24, no real data
 *   - "N orders delivered in <city> this month" -> number derived from a hash of
 *     the city name. Entirely invented, and it sent every visitor's IP to a
 *     third-party geolocation service to do it.
 *   - "Lowest Price Guaranteed / we'll match it" -> price-match promise
 *   - "4,800+ Orders Delivered" -> actual fulfilled order count is far lower
 *   - "4.8 star Customer Rating" -> no review system backing it
 *   - "Prepaid orders dispatch same day" -> prepaid is not available at checkout
 *   - WELCOME10 first-visit popup -> code was already disabled
 */
var SARAZ_CTK = {
  whatsappPhone: "919106515891",
  askText: function (title, url) { return "Hi! I want to ask about: *" + title + "*\n" + url; },
  shareText: function (title, url) { return "✨ Check this out on Saraz Outlet: *" + title + "*\n" + url; },
  exitText: function () { return "Hi! I was browsing Saraz Outlet and want to know more about your products 😊"; },
  exitIntentEnabled: true,
  exitIntentDelay: 5000,
  exitIntentSessionKey: "saraz_ei_shown"
};

(function () {
  "use strict";

  var isProduct = window.location.pathname.indexOf("/products/") !== -1;
  var isHome = window.location.pathname === "/" || window.location.pathname === "";

  function title() {
    var el = document.querySelector(".product__title") || document.querySelector("h1");
    return el ? el.innerText.trim() : document.title;
  }
  function waLink(phone, text) { return "https://wa.me/" + phone + "?text=" + encodeURIComponent(text); }
  function buyButtons() {
    return document.querySelector(".product-form__buttons") || document.querySelector("product-form .product-form__buttons");
  }
  function productForm() {
    return document.querySelector("product-form") || document.querySelector(".product-form") || document.querySelector(".saraz-pdp__form");
  }
  function addStyle(id, css) {
    if (document.getElementById(id)) return;
    var s = document.createElement("style");
    s.id = id; s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---- WhatsApp ask / share ---- */
  function whatsappRow() {
    if (!isProduct) return;
    var anchor = buyButtons();
    if (!anchor || document.getElementById("saraz-wa-row")) return;

    var canonical = document.querySelector('link[rel="canonical"]');
    var url = canonical ? canonical.href : window.location.href;
    var t = title();

    addStyle("saraz-wa-css", "#saraz-wa-row a:hover{opacity:.82!important}");

    var row = document.createElement("div");
    row.id = "saraz-wa-row";
    row.style.cssText = "display:flex;gap:10px;margin-top:12px;flex-wrap:wrap";
    row.appendChild(waButton("Ask on WhatsApp", waLink(SARAZ_CTK.whatsappPhone, SARAZ_CTK.askText(t, url)), "#25D366"));
    row.appendChild(waButton("Share on WhatsApp", "https://wa.me/?text=" + encodeURIComponent(SARAZ_CTK.shareText(t, url)), "#128C7E"));

    if (anchor.nextSibling) { anchor.parentNode.insertBefore(row, anchor.nextSibling); }
    else { anchor.parentNode.appendChild(row); }
  }

  function waButton(label, href, bg) {
    var a = document.createElement("a");
    a.href = href; a.target = "_blank"; a.rel = "noopener noreferrer";
    a.style.cssText = [
      "display:inline-flex", "align-items:center", "gap:7px", "background:" + bg,
      "color:#fff", "border-radius:6px", "padding:9px 14px", "font-size:13px",
      "font-weight:600", "text-decoration:none", "flex:1 1 auto",
      "justify-content:center", "min-width:140px", "transition:opacity .2s", "cursor:pointer"
    ].join(";");
    a.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden="true" style="flex-shrink:0"><path d="M12 0C5.4 0 0 5.4 0 12c0 2.1.6 4.1 1.5 5.8L0 24l6.4-1.5C8 23.4 10 24 12 24c6.6 0 12-5.4 12-12S18.6 0 12 0zm5.2 16.5l-1.9-.6a.7.7 0 00-.7.2l-.5.5a.7.7 0 01-.8.2c-.9-.3-2.7-1.8-3.5-3.5a.7.7 0 01.2-.8l.5-.5a.7.7 0 00.2-.7L10 9.3a.7.7 0 00-.7-.5H8.3c-.5 0-.8.6-.8 1.2 0 4.3 4.2 7.5 7.5 7.5.6 0 1.2-.3 1.8-.8h1.2a.7.7 0 00.7-1z"/></svg><span>' + label + "</span>";
    return a;
  }

  /* ---- PIN code delivery estimate ---- */
  function pinChecker() {
    if (!isProduct) return;
    var host = productForm();
    if (!host || document.getElementById("saraz-pin-widget")) return;

    addStyle("saraz-pin-css", [
      "#saraz-pin-widget{margin-top:14px;padding:12px;background:#fafafa;border:1px solid #e0e0e0;border-radius:8px}",
      "#saraz-pin-row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}",
      "#saraz-pin-input{flex:1 1 140px;padding:8px 10px;border:1px solid #bdbdbd;border-radius:6px;font-size:13px;outline:none}",
      "#saraz-pin-input:focus{border-color:#3D2A5A}",
      "#saraz-pin-btn{background:#3D2A5A;color:#fff;border:none;border-radius:6px;padding:8px 14px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap}",
      "#saraz-pin-btn:hover{background:#5B3D85}",
      "#saraz-pin-result{margin-top:8px;font-size:13px;display:none}"
    ].join(""));

    var w = document.createElement("div");
    w.id = "saraz-pin-widget";
    w.innerHTML = [
      '<div style="font-size:12px;font-weight:600;color:#555;margin-bottom:8px">📦 Check Delivery Date</div>',
      '<div id="saraz-pin-row">',
      '<input id="saraz-pin-input" type="tel" placeholder="Enter PIN code" maxlength="6" inputmode="numeric">',
      '<button id="saraz-pin-btn" type="button">Check</button>',
      "</div>",
      '<div id="saraz-pin-result"></div>'
    ].join("");
    host.appendChild(w);

    function addBusinessDays(from, n) {
      var d = new Date(from), added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      return d;
    }
    function fmt(d) {
      var days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
      var mons = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      return days[d.getDay()] + ", " + d.getDate() + " " + mons[d.getMonth()];
    }

    w.querySelector("#saraz-pin-btn").addEventListener("click", function () {
      var pin = w.querySelector("#saraz-pin-input").value.trim();
      var out = document.getElementById("saraz-pin-result");
      out.style.display = "block";
      if (!/^\d{6}$/.test(pin)) {
        out.innerHTML = '<span style="color:#c0392b">⚠️ Please enter a valid 6-digit PIN code.</span>';
        return;
      }
      var zone = parseInt(pin[0], 10);
      var days = zone <= 4 ? 3 : (zone <= 7 ? 4 : 5);
      out.innerHTML = [
        '<div style="color:#2e7d32;font-weight:600;margin-bottom:4px">',
        "✅ Estimated delivery by <strong>" + fmt(addBusinessDays(new Date(), days)) + "</strong> to " + pin,
        "</div>",
        '<div style="font-size:12px;color:#555">Cash on Delivery available on this PIN code.</div>'
      ].join("");
    });

    w.querySelector("#saraz-pin-input").addEventListener("keydown", function (e) {
      if (e.key === "Enter") { w.querySelector("#saraz-pin-btn").click(); }
    });
  }

  /* ---- Header trust strip (verifiable claims only) ---- */
  function trustStrip() {
    if (!isHome || document.getElementById("saraz-order-strip")) return;
    addStyle("saraz-strip-css", [
      "#saraz-order-strip{background:#3D2A5A;color:#fff;padding:10px 20px;text-align:center;font-size:14px;font-weight:600;letter-spacing:.3px;display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap}",
      "#saraz-order-strip .saraz-strip-item{display:flex;align-items:center;gap:6px}",
      "@media(max-width:600px){#saraz-order-strip{font-size:12.5px;padding:8px 12px}}"
    ].join(""));
    var strip = document.createElement("div");
    strip.id = "saraz-order-strip";
    strip.innerHTML = [
      '<span class="saraz-strip-item"><span>🚚</span><span>Free Delivery Across India</span></span>',
      '<span style="opacity:.4">|</span>',
      '<span class="saraz-strip-item"><span>💵</span><span>Cash on Delivery Available</span></span>',
      '<span style="opacity:.4">|</span>',
      '<span class="saraz-strip-item"><span>🔄</span><span>Easy Returns</span></span>'
    ].join("");
    var header = document.getElementById("shopify-section-header") || document.querySelector("header") || document.getElementById("MainContent");
    if (header && header.nextSibling) { header.parentNode.insertBefore(strip, header.nextSibling); }
    else if (header) { header.parentNode.appendChild(strip); }
    else { document.body.insertBefore(strip, document.body.firstChild); }
  }

  /* ---- Exit-intent WhatsApp help ---- */
  function exitIntent() {
    if (!SARAZ_CTK.exitIntentEnabled) return;
    if (sessionStorage.getItem(SARAZ_CTK.exitIntentSessionKey)) return;

    addStyle("saraz-ei-css", [
      "#saraz-ei-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99999;display:flex;align-items:center;justify-content:center;animation:sarazFadeIn .25s ease}",
      "@keyframes sarazFadeIn{from{opacity:0}to{opacity:1}}",
      "#saraz-ei-box{background:#fff;border-radius:14px;padding:32px 28px;max-width:380px;width:90%;text-align:center;position:relative;box-shadow:0 20px 60px rgba(0,0,0,.25)}",
      "#saraz-ei-close{position:absolute;top:12px;right:16px;font-size:22px;background:none;border:none;cursor:pointer;color:#666;line-height:1}",
      "#saraz-ei-title{font-size:22px;font-weight:700;margin:0 0 8px;color:#1a1a2e}",
      "#saraz-ei-sub{font-size:14px;color:#555;margin:0 0 20px;line-height:1.5}",
      "#saraz-ei-wa-btn{display:inline-flex;align-items:center;gap:8px;background:#25D366;color:#fff;border:none;border-radius:8px;padding:12px 22px;font-size:15px;font-weight:700;cursor:pointer;text-decoration:none;width:100%;justify-content:center}",
      "#saraz-ei-wa-btn:hover{background:#1ebe57}",
      "#saraz-ei-skip{display:block;margin-top:12px;font-size:12px;color:#999;cursor:pointer;background:none;border:none}"
    ].join(""));

    var fired = false, armed = false;
    setTimeout(function () { armed = true; }, SARAZ_CTK.exitIntentDelay);

    document.addEventListener("mouseleave", function (e) {
      if (!armed || fired || e.clientY > 20) return;
      fired = true;
      sessionStorage.setItem(SARAZ_CTK.exitIntentSessionKey, "1");
      showPopup();
    });

    function showPopup() {
      var overlay = document.createElement("div");
      function close() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }
      overlay.id = "saraz-ei-overlay";
      overlay.innerHTML = [
        '<div id="saraz-ei-box">',
        '<button id="saraz-ei-close" aria-label="Close">×</button>',
        '<div style="font-size:38px;margin-bottom:8px">🛍️</div>',
        '<p id="saraz-ei-title">Wait — before you go!</p>',
        '<p id="saraz-ei-sub">Have a question? Our team is on WhatsApp right now.<br>Chat with us and we’ll help you find exactly what you need.</p>',
        '<a id="saraz-ei-wa-btn" href="' + waLink(SARAZ_CTK.whatsappPhone, SARAZ_CTK.exitText()) + '" target="_blank" rel="noopener">',
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="#fff" style="flex-shrink:0"><path d="M12 0C5.4 0 0 5.4 0 12c0 2.1.6 4.1 1.5 5.8L0 24l6.4-1.5C8 23.4 10 24 12 24c6.6 0 12-5.4 12-12S18.6 0 12 0zm5.2 16.5l-1.9-.6a.7.7 0 00-.7.2l-.5.5a.7.7 0 01-.8.2c-.9-.3-2.7-1.8-3.5-3.5a.7.7 0 01.2-.8l.5-.5a.7.7 0 00.2-.7L10 9.3a.7.7 0 00-.7-.5H8.3c-.5 0-.8.6-.8 1.2 0 4.3 4.2 7.5 7.5 7.5.6 0 1.2-.3 1.8-.8h1.2a.7.7 0 00.7-1z"/></svg>',
        "<span>Chat with us on WhatsApp</span>",
        "</a>",
        '<button id="saraz-ei-skip">No thanks, I’ll keep browsing</button>',
        "</div>"
      ].join("");
      document.body.appendChild(overlay);
      overlay.querySelector("#saraz-ei-close").addEventListener("click", close);
      overlay.querySelector("#saraz-ei-skip").addEventListener("click", close);
      overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    }
  }

  function init() {
    whatsappRow();
    pinChecker();
    trustStrip();
    exitIntent();
  }

  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", init); }
  else { init(); }

  document.addEventListener("shopify:section:load", function () { whatsappRow(); pinChecker(); });
})();